import { makeVar } from "@apollo/client";
import { PaletteMode } from "@mui/material";
import { themeMode } from "./providers/theme/MuiThemeProvider";
import { getLocationFromLocalStorageByMainStorageKey } from "./helpers/getLocationFromLocalStorage";
import { selectedLocationDropdownVariable } from "./variables/selectedLocationDropdown";

const themeModeStorage = localStorage.getItem("themeMode") as PaletteMode;
let defaultValue = themeMode.light;

if (themeModeStorage) {
  defaultValue = themeModeStorage;
} else {
  localStorage.setItem("themeMode", defaultValue);
}

export const themeModeVariable = makeVar<PaletteMode>(defaultValue);

const parsedValue = getLocationFromLocalStorageByMainStorageKey();

// Avoid overwriting the reactive var with an "empty" selection ({ title: "", value: "" })
// which can lead to unintended resets on refresh.
if (parsedValue?.value) {
  selectedLocationDropdownVariable(parsedValue);
}
